import { render } from "./BbNumberPicker.vue?vue&type=template&id=5500c71a&scoped=true"
import script from "./BbNumberPicker.vue?vue&type=script&lang=js"
export * from "./BbNumberPicker.vue?vue&type=script&lang=js"

import "./BbNumberPicker.vue?vue&type=style&index=0&id=5500c71a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5500c71a"]])

export default __exports__